<template>
<div>

    <!-- Button -->

    <div class="chat-button-outer" :class="{'blue-pulse': mode == 'alert'}">
        <div class="elevation-5 chat-button-inner" :class="{'blue-chat-button': mode == 'alert', 'white-chat-button': mode == 'open'}" @click="buttonClicked" @dblclick="changeMode">
            <v-icon class="button-icon" large>mdi-chat</v-icon>
        </div>
    </div>

    <!-- Window  -->

    <div class="chat-window-outer" :class="{'active': (mode == 'open')}" @click.stop>
        <div class="elevation-1 chat-window-inner">

            <div class="pa-2" style="position:relative;flex-basis:1px; background-color:#eee;border-bottom:solid 1px #aaa;border-radius:10px 10px 0 0">
                <v-icon class="clickable close-chat"  style="font-size:22px;position:absolute;width:20px;height:20px;top:5px;right:5px;" @click="mode='idle'">cancel</v-icon>
                <LabelMenu style="width:95%" v-model="office" :menus="menuItems"/>
            </div>

            <ScrollDownDiv @change="chatsAdded" class="pa-2" style="flex-grow:1;overflow-y:auto;" ref="history">
                <div @click="messageLimit += 10" v-if="messages.length == messageLimit" class="hoverable clickable light-text small-text">Show More History</div>
                <div v-for="message in messages" :class="{reversed: isMyMessage(message)}" class="chat-message" style="display:flex" :key="message._id">
                    <img :src="message.user.image" style="flex-basis:40px" class="chat-message-picture">

                    </img>
                    <div style="flex-grow:1">
                        <div  class="chat-message-text" :class="{'chat-message-blue': isMyMessage(message)}">
                            {{message.text}} <span class="light-text small-text">{{message.createdAt | timeAgo}}</span>
                        </div>
                    </div>
                </div>
            </ScrollDownDiv>
            <div class="pa-2" style="flex-basis:35px;">
                <input type="text" v-model="newMessage" ref="messageText" class="quick-input" @keypress.enter.prevent="saveMessage" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import LabelMenu from '../ui-elements/LabelMenu'
import ScrollDownDiv from '../ui-elements/ScrollDownDiv'
import StringHelpers from '../helpers/StringHelpers'
import LookupData from '../helpers/LookupData'
import Firestore from '../data/Firestore'

export default {
    data() {
        return {
            newMessage: '',
            mode: 'idle',
            messages: [],
            office: '1',
            messageLimit: 10,
        }
    },

    components: {
        LabelMenu,
        ScrollDownDiv,
    },
    
    props: {
        item: Object,
    },

    computed: {


        currentUserImage() {
            return DataHelpers.getUser().image
        },
        
        menuItems() {
            return this.offices.map(o => {
                return {
                    text: o.name,
                    value: o.meta.key,
                }
            })
        },
        offices() {
            return this.$store.getters.officesActive
        },
        
        chatPath() {
            const teamName = LookupData.officeTeams()[this.office]
            const teamSlug = StringHelpers.toCamelCase(teamName)
            return `/teams/${teamSlug}/collections/chats/data`
        }

    },

    methods: {

        isMyMessage(message) {
            // debugger
            return message.user.uid == DataHelpers.getUser().uid
        },

        chatsAdded() {
            if(this.mode == 'idle')
                this.mode = 'alert'
        }, 

        loadMessages() {
            console.log('loading messages')
            let ref = Firestore.getCollectionDocumentRefFromPath(this.chatPath).orderBy('createdAt', "desc").limit(this.messageLimit)
            return Firestore.streamCollection(ref, this.messages, {reverse: true})
        },

        saveMessage() {
            if(!this.newMessage)
                return
            console.log(this.newMessage)
            //this.messages.push({message: this.newMessage})

            Firestore.saveItem({
                text: this.newMessage,
                user: DataHelpers.getUser(),
                _path: this.chatPath
            }).then( () => {
 
            })

            this.newMessage = ''
        },

        // scrollToEnd() {
        //     setTimeout( () => {
        //         let el = this.$refs.history.lastChild
        //         if(el)
        //             el.scrollIntoView({ behavior: 'smooth', block: 'end' });
        //     },100)
        // },

        buttonClicked() {
            this.changeMode()
            if(this.mode == 'open')
                this.$refs.messageText.focus()
            
        },
        changeMode() {
            if(this.mode == 'open')
                this.mode = 'idle'
            else
                this.mode = 'open'
                console.log('mode changed to ', this.mode)
        }
    },

    created() {
        setTimeout(()=>{
            
            const office = this.$store.getters.tenant.key
            
            this.office = office

            this.loadMessages()

            // this.$refs.history.addEventListener('DOMNodeInserted', function() {
            //     console.log('dom node inserted')
            // })
        },500)
    },

    watch: {
        'messageLimit': {
            immediate: false,
            handler: function() {
                
                this.loadMessages()
            }
        },
        'office': {
            immediate: false,
            handler: function() {
                
                this.loadMessages()
            }
        }
    }

}
</script>

<style scoped>

    .reversed {
        flex-direction: row-reverse;
    }

    .quick-input:focus {
        outline: none;
    }

    .close-chat {
        color:rgba(255,77,77,.5);
    }

    .close-chat:hover {
        color:rgba(255,77,77,1);
    }

    .button-icon {
        margin-left:12px;margin-top:12px;
        color:rgba(80,80,80,0.3)
    }

    .chat-button-outer {
        border-radius:50%;
        position:fixed;
        width:65px;height:65px;
        background-color:transparent;
        bottom:20px;right:20px;
        z-index:100;
        padding-left:3px;padding-top:3px;
    }
    .chat-button-outer:hover {
        background-color:rgba(100,100,100,0.1)
    }
    .chat-button-inner {
        border-radius:50%;width:60px;height:60px;
        background-color:rgba(180,180,180,0.7);
        cursor: pointer;
    }
    .chat-button-inner.blue-chat-button {
        background-color: rgba(153,204,255, .8)
    }
    .chat-button-inner.blue-chat-button > .button-icon {
        color: rgba(0,115,230, .6)
    }
    .chat-button-inner.white-chat-button {
        background-color: rgba(240,240,240, .9)
    }
    .chat-button-inner.white-chat-button > .button-icon {
        color: rgba(200,200,200, .6)
    }

    .chat-window-outer {
        border-radius:10px;
        position:fixed;
        width:285px;
        background-color:transparent;
        bottom:100px;right:20px;
        z-index:100;
        padding-left:3px;padding-top:3px;
        opacity: 0; height: 0px;
        /* opacity: 100%;height:355px; */
        overflow: hidden;
        transition: all .3s ease-in-out;

    }

    .chat-window-outer.active{
        opacity:1;height:385px;
    }

    .chat-window-outer:hover {
        background-color:rgba(100,100,100,0.1)
    }
    .chat-window-inner {
        border-radius:10px;width:280px;height:380px;
        border:solid 2px #bbb;
        background-color:rgba(255,255,255,0.9);
        display: flex; flex-direction: column;
    }

    .chat-message {
        margin:4px;
    }
    .chat-message-text {
        border:solid 1px #ccc;
        background-color:#eee;
        border-radius: 15px;
        padding:4px 8px;
        margin-top:3px;
    }
    .chat-message-text.chat-message-blue {
        border:solid 1px rgb(5, 171, 236);
        background-color:rgba(177, 218, 252, 0.404);
    }
    .chat-message-picture {
        width:40px;height:40px;border:solid 1px #ccc;border-radius: 50%;margin:0 5px;
    }
   
</style>




// WEBPACK FOOTER //
// ChatWindow.vue?2b2c64fb